<template>
  <div class="qr-modal-background">
    <div class="qr-modal-container">
      <h1>{{ title || $t('qrCode.title') }}</h1>
      <p class="qr-modal-instruction">{{ $t('qrCode.instruction') }}</p>

      <div class="qr-modal-code" v-if="showCode">
        <img class="qr-modal-image" :src="codeImageUrl" :alt="url" @error="codeDidFailToLoad" />
      </div>

      <p class="qr-modal-url">{{ displayUrl(url) }}</p>

      <TG4Button
        id="qr-modal-close"
        :title="$t('general.close')"
        primary
        large
        v-focus
        data-up="AUTOFOCUS"
        data-down="AUTOFOCUS"
        data-left="AUTOFOCUS"
        data-right="AUTOFOCUS"
        v-press="() => emit('close')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">

import { ref, computed, onMounted } from 'vue';
import { navigationService } from 'vue-spatialnavigation';
import { qrCodeImageUrl, displayUrl } from '@/helpers/qr-code';
import TG4Button from '@/components/TG4Button.vue';

const props = defineProps<{
  url: string;
  title?: string;
}>();

const emit = defineEmits<{
  (e: 'close'): void
}>();

const codeImageUrl = computed(() => qrCodeImageUrl(props.url));

const showCode = ref(true);

const codeDidFailToLoad = () => {
  showCode.value = false;
};

onMounted(() => {
  setTimeout(() => {
    const element = navigationService.getFocusElementById('qr-modal-close');
    if (element) element.focus();
  }, 200);
});
</script>

<style scoped lang="scss">

.qr-modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: $color-background-grey;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.qr-modal-container {
  font-family: $font-tg4;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 120px;

  h1 {
    @include text-title;
    @include text-white;
    margin: 0 0 20px 0;
    text-align: center;
  }
}

.qr-modal-instruction {
  @include text-subtitle;
  @include text-white;
  max-width: 1400px;
  margin: 0 0 30px 0;
  text-align: center;
}

.qr-modal-code {
  background-color: $color-off-white;
  padding: 10px;
  margin: 0 0 30px 0;
}

.qr-modal-image {
  display: block;
  width: 380px;
  height: 380px;
}

.qr-modal-url {
  @include text-cell-title;
  @include text-white;
  max-width: 1400px;
  margin: 0 0 40px 0;
  text-align: center;
  word-break: break-all;
}
</style>
